import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import HoursByProject from '../components/management/HoursByProject'
import WeeklyHourLimits from '../components/management/WeeklyHourLimits'
import ProjectBudgets from '../components/management/ProjectBudgets'

export default function GeneralManagement() {
  const { t } = useTranslation('engineering')
  const HASHES = { '#limits': 'limits', '#budgets': 'budgets' }
  const initialTab = (typeof window !== 'undefined'
    && HASHES[window.location.hash]) || 'hours'
  const [tab, setTab] = useState(initialTab)

  const selectTab = (next) => {
    setTab(next)
    if (typeof window !== 'undefined') {
      const hash = next === 'hours' ? '' : `#${next}`
      history.replaceState(null, '', window.location.pathname + window.location.search + hash)
    }
  }

  const tabClass = (id) => `px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${
    tab === id ? 'border-gray-900 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-800'
  }`

  return (
    <div>
      <div className="px-8 pt-6">
        <div className="flex items-center gap-1 border-b border-gray-200">
          <button onClick={() => selectTab('hours')} className={tabClass('hours')}>
            {t('management.tabHours')}
          </button>
          <button onClick={() => selectTab('limits')} className={tabClass('limits')}>
            {t('management.tabLimits')}
          </button>
          <button onClick={() => selectTab('budgets')} className={tabClass('budgets')}>
            {t('management.tabBudgets')}
          </button>
        </div>
      </div>
      {tab === 'hours' && <HoursByProject />}
      {tab === 'limits' && <WeeklyHourLimits />}
      {tab === 'budgets' && <ProjectBudgets />}
    </div>
  )
}
